<oqs-top-panel
  oqs-logo-url="summary.data.quoteDefinition.sbuDetails.webLogoUrl"
  oqs-logo-link="summary.getSbuWebsite()"
  oqs-broker-logo-url="summary.data.selectedBroker.logoUrl">
  <span>Your {{summary.data.viewModel.selectedQuoteType.definition.name}} Quote</span>
</oqs-top-panel>

<div class="oqs-left-panel">
  <div class="oqs-navigation">
    <div class="col-xs-6 oqs-navigation-back">
      <a ui-sref="quote({brokerRef: summary.data.selectedBroker.id})" class="btn btn-primary btn-block">
        <div class="oqs-btn-icon">
          <span class="fa fa-chevron-circle-left fa-2x"></span>
        </div>
        <span class="oqs-btn-label" oqs-message="summary.button.backButton"></span>
      </a>
    </div>
    <div class="col-xs-6 oqs-navigation-next">
      <a class="btn btn-primary btn-block" ng-click="summary.openContactModal()">
        <div class="oqs-btn-icon">
          <span class="fa fa-chevron-circle-right fa-2x"></span>
        </div>
        <span class="oqs-btn-label" oqs-message="summary.button.forwardButton"></span>
      </a>
    </div>
  </div>

  <div class="oqs-quote-response">
    <div class="oqs-quote-response-success">
      <span class="month">{{ summary.data.quoteResponse.data.monthlyPremium | currency }}<small>/month</small></span>
      <span class="year">{{ summary.data.quoteResponse.data.annualPremium | currency }}<small>/year</small></span>
    </div>
  </div>
  <div class="oqs-company-snippet" oqs-message="global.html.companySnippet" oqs-message-html>
  </div>
</div>

<div class="oqs-right-panel">
  <div class="oqs-address">
    <div class="row">
      <div class="col-sm-6">
        <strong>{{ summary.data.quoteDefinition.sbuDetails.name }}</strong>
        <div class="oqs-broker-address">{{ summary.data.quoteDefinition.sbuDetails.address}}</div>
      </div>
      <div class="col-sm-6">
        <a ui-sref="broker" class="btn btn-sm btn-default pull-right">Change</a>
        <strong>{{ summary.data.selectedBroker.name }}</strong>
        <div class="oqs-broker-address">{{summary.data.selectedBroker.address}}</div>
      </div>
    </div>
  </div>
  <div class="row">
    <div>
      <div class="col-xs-12 col-sm-8">
        <div class="oqs-summary-date">{{summary.moment().format('dddd, MMMM Do YYYY, h:mma')}}</div>
      </div>
      <div class="col-xs-12 col-sm-4">
        <div class="text-right oqs-summary-reference" ng-if="summary.referenceNumber">Reference
          #{{summary.referenceNumber}}
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="oqs-summary-details col-xs-12">
      <div class="oqs-heading" oqs-message="summary.html.summaryHeading" oqs-message-html></div>
      <div class="oqs-sub-heading" oqs-message="summary.html.summarySubHeading" oqs-message-html></div>
      <div class="oqs-totals">
        <div class="row">
          <div class="col-sm-6">{{summary.data.viewModel.selectedQuoteType.definition.name}} Quote</div>
          <div class="col-sm-6 text-right">
            {{ summary.data.quoteResponse.data.monthlyPremium | currency }}
            <small>/month</small>
            {{ summary.data.quoteResponse.data.annualPremium | currency }}
            <small>/year</small>
          </div>
        </div>
      </div>
      <div class="oqs-item" ng-repeat="item in summary.data.quoteResponse.data.details.itemList">
        <div class="oqs-item-name" ng-bind="item.name"></div>
        <div class="oqs-item-description" ng-if="item.description" ng-bind="item.description"></div>
        <div class="oqs-item-coverage-group" ng-repeat="coverageGroup in item.coverageGroupList">
          <table class="table table-striped">
            <thead>
            <tr>
              <th colspan="3" ng-if="coverageGroup.name" ng-bind="coverageGroup.name"></th>
            </tr>
            <tr>
              <th>Coverage</th>
              <th class="text-right">Deductible</th>
              <th class="text-right">Limit</th>
            </tr>
            </thead>
            <tbody>
            <tr ng-repeat="coverage in coverageGroup.coverageList">
              <td ng-bind="coverage.name"></td>
              <td class="text-right">{{ coverage.deductible | currency:"$":0 }}</td>
              <td class="text-right">{{ (coverage.limit > 0) ? (coverage.limit | currency:"$":0) : ""}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="oqs-asterisk" oqs-message="summary.html.summaryFooter" oqs-message-html>
      </div>
      <div class="oqs-download-quote">
        <button class="btn btn-default" ng-click="summary.downloadQuotePdf()"
                ng-class="{'disabled': summary.downloadInProgress}"
                ng-if="summary.showEmailButton()">
          <span class="summary fa fa-file-pdf-o"
                ng-class="{'fa-file-pdf-o': !summary.downloadInProgress, 'fa-spinner fa-pulse': summary.downloadInProgress}"></span>
          <span class="summary oqs-label" oqs-message="summary.button.download"></span>
        </button>
        <button class="btn btn-default" ng-click="summary.openEmailModal()"
                ng-class="{'disabled': summary.downloadInProgress}"
                ng-if="summary.showDownloadButton()">
          <span class="summary fa fa-envelope-o"></span>
          <span class="summary oqs-label" oqs-message="summary.button.email"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="col-xs-12">
    <div class="oqs-navigation row">
      <div class="col-xs-6 oqs-navigation-back">
        <a ui-sref="quote({brokerRef: summary.data.selectedBroker.id})" class="btn btn-primary btn-block">
          <div class="oqs-btn-icon">
            <span class="fa fa-chevron-circle-left fa-2x"></span>
          </div>
          <span class="oqs-btn-label" oqs-message="summary.button.backButton"></span>
        </a>
      </div>
      <div class="col-xs-6 oqs-navigation-next">
        <a class="btn btn-primary btn-block" ng-click="summary.openContactModal()">
          <div class="oqs-btn-icon">
            <span class="fa fa-chevron-circle-right fa-2x"></span>
          </div>
          <span class="oqs-btn-label" oqs-message="summary.button.forwardButton"></span>
        </a>
      </div>

    </div>
  </div>

</div>


